import React, { useEffect, useState, useContext } from "react";
// react-bootstrap components
import { Card, Form, Container, Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router";
import { apiService } from "../../../service/ApiService";
import { notificationService } from "../../../service/NotificationService";
import CreateButton from "components/Buttons/CreateButton";
import EditButton from "components/Buttons/EditButton";
import GeneralStoreSelect from "components/DropDowns/GeneralStoreSelect";

import { useTranslation } from "react-i18next";

function PricelistPage() {
  const {
    t,
  } = useTranslation();

  const backRoute = "/admin/pricelists";
  const history = useHistory();
  const { id } = useParams();
  const [name, setName] = useState("");
  const [storeId, setStoreId] = useState(null);
  const [pricelistDeleted, setPricelistDeleted] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  const handleStoreId = (id) => {
    setStoreId(id);
  }

  useEffect(() => {
    if (!id) return;
    apiService
      .get(`api/v1/pricelists/${id}`)
      .then((pricelist) => {
        fillFields(pricelist);
      })
      .catch((error) => {
        notificationService.notifyError(error.message);
        history.push(backRoute);
      });
  }, []);

  const save = () => {
    setIsDisabled(true);
    const pricelist = {
      name: name ? name : undefined,
      storeId: storeId,
      deleted: pricelistDeleted,
    };
    if (id) {
      apiService
        .putJson(`api/v1/pricelists/${id}`, pricelist)
        .then((resp) => {
          notificationService.notifySuccess(t("messages.priceListSavedSuccessfully"));
          history.push(backRoute);
          setIsDisabled(false);
        })
        .catch((error) => {
          setErrorMessage(error.message);
          notificationService.notifyError(error.message);
          setIsDisabled(false);
        });
    } else {
      apiService
        .postJson("api/v1/pricelists", pricelist)
        .then((resp) => {
          notificationService.notifySuccess(t("messages.priceListCreatedSuccessfully"));
          history.push(backRoute);
          setIsDisabled(false);
        })
        .catch((error) => {
          setErrorMessage(error.message);
          notificationService.notifyError(error.message);
          setIsDisabled(false);
        });
    }
  };

  const fillFields = (pricelist) => {
    setName(pricelist.name);
    setPricelistDeleted(pricelist.deleted);
  };

  return (
    <>
      <Container fluid>
        <Row>
          <Col md="12">
            <Card className="stacked-form">
              <Card.Header>
                <Card.Title as="h4">{id ? t("pages.titles.editPriceList") : t("pages.titles.createPriceList")}</Card.Title>
              </Card.Header>
              <Card.Body>
                {errorMessage ? <div style={{ color: "crimson" }}>{errorMessage}</div> : null}
                <Form action="#" method="#">
                  <Row>
                    <Col>
                      <Form.Group>
                        <label>{t("common.labels.designation")}</label>
                        <Form.Control
                          placeholder={t("common.labels.designation")}
                          required={true}
                          type="text"
                          value={name}
                          onChange={(event) => setName(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col>
                      <GeneralStoreSelect title={t("common.labels.store")} disabled={true} selectedStoreId={handleStoreId} />
                    </Col>
                  </Row>
                  <Row>
                    <Col md="1">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check
                            type="switch"
                            id="switch-1"
                            checked={pricelistDeleted}
                            onChange={(e) => setPricelistDeleted(e.target.checked)}
                          />
                          <span className="ml-1">{t("common.labels.inactive")}</span>
                        </label>
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
                <Row className="float-right">
                  <Col>{id ? <EditButton handler={save} disabled={isDisabled}/> : <CreateButton handler={save} disabled={isDisabled} />}</Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default PricelistPage;
